export default __webpack_public_path__ + "static/media/bet10.168a687d.png";